import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kw-contacts-nav',
  templateUrl: './contacts-nav.component.html',
  styleUrls: ['./contacts-nav.component.scss']
})
export class ContactsNavComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
